import { Box, Text } from '@factorialco/deprecated-design-system'
import { AnimatePresence, motion } from 'framer-motion'

import i18n from 'modules/core/lib/i18n'

export const EmptyCategoryList = () => {
  const container = {
    hidden: { opacity: 0 },
    show: {
      opacity: 1,
      transition: {
        staggerChildren: 0.1,
      },
    },
  }

  return (
    <AnimatePresence>
      <motion.div layout variants={container} initial="hidden" animate="show">
        <Box width="full" justifyContent="center" flexDirection="row" padding="s48">
          <Text.Normal>{i18n.t('marketplace.filters.no_results')}</Text.Normal>
        </Box>
      </motion.div>
    </AnimatePresence>
  )
}
